'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _ElementDropTarget = require('../dnd/ElementDropTarget');

var _ElementDropTarget2 = _interopRequireDefault(_ElementDropTarget);

var _elementHelper = require('../../../common/elements/elementHelper');

var _keyboardUtility = require('../../utils/keyboard/keyboardUtility');

var _columnActions = require('./columnActions');

var _boardConstants = require('../../../common/boards/boardConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions


// Utils
// Lib
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        createColumnOnDrop: function createColumnOnDrop(location, childIdArray) {
            return dispatch((0, _columnActions.createColumnWithChildren)({ location: location, childIdArray: childIdArray }));
        }
    };
};

// Constants


// Custom Decorators


var cardDropTargetHandler = function cardDropTargetHandler(props, monitor, component) {
    var createColumnOnDrop = props.createColumnOnDrop,
        element = props.element;


    var handledBy = _reactDom2.default.findDOMNode(component);

    var _monitor$getItem = monitor.getItem(),
        draggedElements = _monitor$getItem.draggedElements;

    var acceptedElementIds = draggedElements.filter(function (el) {
        return !(0, _elementHelper.isLine)(el) && !(0, _elementHelper.isColumn)(el);
    }).map(function (el) {
        return el.get('id');
    });

    var childIdArray = [element.get('id')];

    var _createColumnOnDrop = createColumnOnDrop(element.get('location').toJS(), childIdArray),
        columnElementId = _createColumnOnDrop.columnElementId,
        transactionId = _createColumnOnDrop.transactionId;

    return {
        acceptedElementIds: acceptedElementIds,
        location: {
            parentId: columnElementId,
            section: _boardConstants.BOARD_SECTIONS.INBOX,
            position: {
                index: childIdArray.length
            }
        },
        handledBy: handledBy,
        transactionId: transactionId
    };
};

var canDropHandler = function canDropHandler(props, monitor) {
    var inList = props.inList,
        dragModifierKeys = props.dragModifierKeys;

    if (inList) return false;

    var _monitor$getItem2 = monitor.getItem(),
        draggedElements = _monitor$getItem2.draggedElements;

    if (draggedElements.every(function (el) {
        return (0, _elementHelper.isColumn)(el) || (0, _elementHelper.isLine)(el);
    })) return false;

    return (0, _keyboardUtility.hasCommandModifier)(dragModifierKeys);
};

/**
 * This decorator adds the ability to create a column when another element is dropped onto this element.
 * The new column will contain this element as well as the dropped element.
 *
 * @param Element {ReactComponent} The element to turn into a column on drop - drop target.
 */

exports.default = function (Element) {
    return (0, _recompose.compose)((0, _reactRedux.connect)(null, mapDispatchToProps), (0, _ElementDropTarget2.default)({ drop: cardDropTargetHandler, canDrop: canDropHandler }, null))(Element);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/column/ColumnOnDropDropTarget.js
// module id = 452
// module chunks = 0